export const T = {
  en_GB: {
    clients: { one: (n: number) => `${n} client`, other: (n: number) => `${n} clients` },
    noClients: "There are no clients yet — nothing changes for anyone today.",
    everyone: {
      one: (n: number) => `Every advisor will see the ${n} client.`,
      other: (n: number) => `Every advisor will see all ${n} clients.`,
    },
    teamsNone: "No teams yet — every client will only be visible to its owner.",
    privateNone:
      "No clients are marked private yet — everyone keeps seeing every client until an advisor ticks Private.",
    visibleToAll: {
      one: (clients: string) => `${clients} stays visible to everyone.`,
      other: (clients: string) => `${clients} stay visible to everyone.`,
    },
    teamLimited: {
      one: (clients: string) => `${clients} is limited to its owner and the members of its teams.`,
      other: (clients: string) =>
        `${clients} are limited to their owner and the members of their teams.`,
    },
    ownerOnly: {
      private: {
        one: (clients: string) => `${clients} marked private will only be visible to its owner.`,
        other: (clients: string) =>
          `${clients} marked private will only be visible to their owner.`,
      },
      team: {
        one: (clients: string) =>
          `${clients} has no team with members and will only be visible to its owner.`,
        other: (clients: string) =>
          `${clients} have no team with members and will only be visible to their owner.`,
      },
      both: {
        one: (clients: string) =>
          `${clients} is marked private or has no team with members, and will only be visible to its owner.`,
        other: (clients: string) =>
          `${clients} are marked private or have no team with members, and will only be visible to their owner.`,
      },
    },
    adminComplianceOnly: {
      private: {
        one: (clients: string) =>
          `${clients} marked private has no active owner and will only be visible to Admin and Compliance.`,
        other: (clients: string) =>
          `${clients} marked private have no active owner and will only be visible to Admin and Compliance.`,
      },
      team: {
        one: (clients: string) =>
          `${clients} has no active owner and no team with members, so only Admin and Compliance will see it.`,
        other: (clients: string) =>
          `${clients} have no active owner and no team with members, so only Admin and Compliance will see them.`,
      },
      both: {
        one: (clients: string) =>
          `${clients} has no active owner and is marked private or has no team with members, so only Admin and Compliance will see it.`,
        other: (clients: string) =>
          `${clients} have no active owner and are marked private or have no team with members, so only Admin and Compliance will see them.`,
      },
    },
  },
  nb_NO: {
    clients: { one: (n: number) => `${n} kunde`, other: (n: number) => `${n} kunder` },
    noClients: "Det finnes ingen kunder ennå — ingenting endres for noen i dag.",
    everyone: {
      one: (_n: number) => "Alle rådgivere vil se den ene kunden.",
      other: (n: number) => `Alle rådgivere vil se alle ${n} kundene.`,
    },
    teamsNone: "Ingen team ennå — alle kunder blir bare synlige for eieren.",
    privateNone:
      "Ingen kunder er merket private ennå — alle ser fortsatt alle kunder til en rådgiver krysser av for Privat.",
    visibleToAll: {
      one: (clients: string) => `${clients} er fortsatt synlig for alle.`,
      other: (clients: string) => `${clients} er fortsatt synlige for alle.`,
    },
    teamLimited: {
      one: (clients: string) => `${clients} er begrenset til eieren og medlemmene i teamene sine.`,
      other: (clients: string) =>
        `${clients} er begrenset til eieren og medlemmene i teamene sine.`,
    },
    ownerOnly: {
      private: {
        one: (clients: string) => `${clients} merket privat blir bare synlig for eieren.`,
        other: (clients: string) => `${clients} merket private blir bare synlige for eieren.`,
      },
      team: {
        one: (clients: string) =>
          `${clients} har ingen team med medlemmer og blir bare synlig for eieren.`,
        other: (clients: string) =>
          `${clients} har ingen team med medlemmer og blir bare synlige for eieren.`,
      },
      both: {
        one: (clients: string) =>
          `${clients} er merket privat eller har ingen team med medlemmer, og blir bare synlig for eieren.`,
        other: (clients: string) =>
          `${clients} er merket private eller har ingen team med medlemmer, og blir bare synlige for eieren.`,
      },
    },
    adminComplianceOnly: {
      private: {
        one: (clients: string) =>
          `${clients} merket privat har ingen aktiv eier og blir bare synlig for Admin og Compliance.`,
        other: (clients: string) =>
          `${clients} merket private har ingen aktiv eier og blir bare synlige for Admin og Compliance.`,
      },
      team: {
        one: (clients: string) =>
          `${clients} har ingen aktiv eier og ingen team med medlemmer, så bare Admin og Compliance ser den.`,
        other: (clients: string) =>
          `${clients} har ingen aktiv eier og ingen team med medlemmer, så bare Admin og Compliance ser dem.`,
      },
      both: {
        one: (clients: string) =>
          `${clients} har ingen aktiv eier og er merket privat eller har ingen team med medlemmer, så bare Admin og Compliance ser den.`,
        other: (clients: string) =>
          `${clients} har ingen aktiv eier og er merket private eller har ingen team med medlemmer, så bare Admin og Compliance ser dem.`,
      },
    },
  },
} as const;
